import throttle from "lodash.throttle";

class Navigation {
    constructor() {
        this.nav = document.querySelector('.site-header');

        if (this.nav !== null) {
            this.topOfNav = this.nav.offsetTop;
            window.addEventListener("scroll", throttle(this.fixNav.bind(this), 10));

            this.openMobileMenu();
        }


    }

    fixNav() {
        if (window.scrollY >= 220) {
            document.body.classList.add('fixed-nav');
            document.body.style.paddingTop = this.nav.offsetHeight + 'px';
        } else {
            document.body.classList.remove('fixed-nav');
            document.body.style.paddingTop = '0';
        }
    }

    openMobileMenu() {
        const closeSidebarsOverlay = document.querySelector('.close-sidebars-overlay');
        const openMobileButton = document.getElementById('toggleNav');
        const mobileMenu = document.querySelector('.sidebar-mobile-menu');

        const openSubmenu = document.querySelectorAll('.open-submenu')

        openMobileButton.addEventListener('click', () => {
            document.body.classList.add('mobile-opened');
            mobileMenu.classList.add('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.add('close-sidebars-overlay--opened');
        });

        closeSidebarsOverlay.addEventListener('click', () => {
            document.body.classList.remove('mobile-opened');
            mobileMenu.classList.remove('sidebar-fixed--opened');
            closeSidebarsOverlay.classList.remove('close-sidebars-overlay--opened');
        });


        openSubmenu.forEach(item => {
            item.addEventListener('click', e => {
                item.parentElement.classList.toggle('nested-submenu--opened');
                this.toggle(item.nextElementSibling);
            })
        });

    }

    show(elem) {

        // Get the natural height of the element
        var getHeight = function () {
            elem.style.display = 'block'; // Make it visible
            var height = elem.scrollHeight + 'px'; // Get it's height
            elem.style.display = ''; //  Hide it again
            return height;
        };

        var height = getHeight(); // Get the natural height
        elem.classList.add('is-visible'); // Make the element visible
        elem.style.height = height; // Update the max-height

        // Once the transition is complete, remove the inline max-height so the content can scale responsively
        window.setTimeout(function () {
            elem.style.height = '';
        }, 350);


    }

    hide(elem) {

        // Give the element a height to change from
        elem.style.height = elem.scrollHeight + 'px';

        // Set the height back to 0
        window.setTimeout(function () {
            elem.style.height = '0';
        }, 1);

        // When the transition is complete, hide it
        window.setTimeout(function () {
            elem.classList.remove('is-visible');
        }, 350);

    };

    toggle(elem, timing) {

        // If the element is visible, hide it
        if (elem.classList.contains('is-visible')) {
            this.hide(elem);
            return;
        }

        // Otherwise, show it
        this.show(elem);

    };


}

export default Navigation;